import type { CloudConnectionType } from "@octopusdeploy/octopus-server-client";
import { session } from "~/clientInstance";

export const getKubernetesTargetDiscoveryCloudProviders: () => Array<CloudConnectionType> = () => (session.features?.IsKubernetesCloudTargetDiscoveryEnabled ? ["Aws", "Azure"] : []);
